<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="50%"
      @close="dialogClosed"
      class="add_playlist"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-width="80px"
          >
            <el-form-item label="歌单标题" prop="list_title">
              <el-input v-model="form.list_title"></el-input>
            </el-form-item>
            <el-form-item label="介绍">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.list_details"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <el-upload
            class="avatar-uploader"
            action="/upload/list"
            :headers="$uploadAuthHeaders()"
            :show-file-list="false"
            :on-success="upload"
          >
            <img
              v-if="form.list_img"
              :src="form.list_img"
              class="avatar"
            />
            <img
              v-else
              src="@/assets/images/default-playlist.png"
              class="avatar"
            />
            <div class="cover">编辑封面</div>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">取 消</el-button>
        <el-button v-no-more-click type="primary" @click="newPlaylist"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    // 弹出层标题
    title: {
      type: String,
      default: "新建歌单",
    },
  },
  data() {
    return {
      singerDetail: {},
      songData: [],
      form: {},
      loading: false,
      rowId: null,
      u_id: null,
      rowSongId: null,
      openAddToPlaylist: false,
      dialogVisible: false,
      userPlaylist: [],
      rules: {
        list_title: [
          { required: true, message: "歌单标题不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 新建歌单
    newPlaylist() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.list_author = window.sessionStorage.getItem("userID");
          const { data: res } = await this.$http.post(
            "api/playlist",
            this.form
          );
          if (res.code !== 200) {
            return this.$message.error("新建歌单失败!");
          }
          this.dialogVisible = false;
          this.getUserPlaylist();
          this.$message.success("新建歌单成功");
        }
      });
    },
    upload(res) {
      this.form.list_img = res.url;
    },
    dialogClosed() {
      this.form.list_title = "";
      this.form.list_details = "";
      this.form.list_img = "";
      this.$refs.form.resetFields();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
::v-deep .el-table__header {
  display: none;
}
::v-deep .el-dialog {
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__header {
    background-color: #5d5d5d;
  }
}
.appendBtn {
  margin-right: 2em;
  font-size: 1.5em;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    color: #ff6491;
  }
}
.append {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-table {
    margin-top: 0;
    .el-table__cell {
      padding: 10px 0;
    }
  }
}
</style>
